export default __webpack_public_path__ + "static/media/Notes.34374db8.png";